import currentUserStorage from 'containers/services/security/current-user-storage';
import { get, isEmpty, isNil } from 'lodash';
import { INSTRUCTION } from 'containers/CourtManagerLegalProceedings/InstructionDrawer/data-structure';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import { InstructionType } from 'typings/globalTypes';

export const isCurrentUser = (
  item: any,
  isManager: Boolean,
  sagisCode: any,
) => {
  return isManager
    ? get(currentUserStorage.get()?.privileges, 'sagisName') === item.createdBy
    : sagisCode === item.lawyerCode;
};
export const isInstructionsRead = (
  instructions: InstructionType[],
  isIntervenants?: boolean,
) => {
  if (isEmpty(instructions)) {
    return true;
  }
  if (!isIntervenants) {
    return instructions.every((item: any) => !!get(item, INSTRUCTION.READ_BY));
  } else {
    return isEmpty(
      instructions.filter(
        (item: any) =>
          !get(item, INSTRUCTION.READ_BY) &&
          get(item, INSTRUCTION.LAWYER_CODE) !=
            currentIntervenantStorage.get()?.sagis_code,
      ),
    );
  }
};
